import { React } from 'Imports';
import { CSVLink } from 'react-csv';
import { Button, Dialog, DialogActions, DialogContent } from 'MaterialUIComponents';
import { ExportButton } from '$Components/FilterComponents/Buttons';
import { useVideoEventExport } from './useVideoEventExport';

import styles = require('./VideoEventExport.scss');

const VideoEventExportComponent: React.FC = () => {
    const { csvLinkRef, videoEventExportData, csvTitle, csvHeaders, canExport, isConfirmDialogOpen, showConfirmDialog, downloadCsvBulk } =
        useVideoEventExport();

    return (
        <span>
            <ExportButton onClick={() => showConfirmDialog(true)} disabled={!canExport} />

            <CSVLink
                ref={csvLinkRef}
                data={videoEventExportData}
                headers={csvHeaders}
                className={styles.fileDownload}
                filename={`${csvTitle}.csv`}
                target="_blank"
            />

            <Dialog open={isConfirmDialogOpen} className={`${styles.confirmationDialog} ${styles.dialog}`}>
                <DialogContent className={styles.confirmMessage}>Are you sure you want to export these events?</DialogContent>
                <DialogActions className={styles.dialogAction}>
                    <Button className={styles.confirmButton} onClick={downloadCsvBulk}>
                        Yes, Export
                    </Button>
                    <Button className={styles.cancelButton} onClick={() => showConfirmDialog(false)}>
                        No, Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </span>
    );
};

export default VideoEventExportComponent;
